module.exports = __webpack_public_path__ + "img/one-line-vehicle-row-mitsu.15b35304.png";